var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-div',{staticClass:"KeyMetrics"},[(_vm.displayIsDesktop)?_c('HorizontalKeyMetrics',{attrs:{"metrics":_vm.metrics,"promotions":_vm.promotions}}):_c('VerticalKeyMetrics',{attrs:{"metrics":_vm.metrics,"promotions":_vm.promotions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }